function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ccc;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-40 -210)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 25,
  height: 25,
  transform: "translate(40 210)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M22.154,5H.886A.9.9,0,0,0,0,5.917V26.083A.9.9,0,0,0,.886,27H22.154a.9.9,0,0,0,.886-.917V5.917A.9.9,0,0,0,22.154,5Zm-.886,1.833V8.667H1.772V6.833ZM1.772,25.167V10.5h19.5V25.167ZM9.748,16h-6.2a.9.9,0,0,0-.886.917v6.417a.9.9,0,0,0,.886.917h6.2a.9.9,0,0,0,.886-.917V16.917A.9.9,0,0,0,9.748,16Zm-.886,6.417H4.43V17.833H8.862v4.583ZM19.5,16H13.3a.9.9,0,0,0-.886.917v6.417a.9.9,0,0,0,.886.917h6.2a.9.9,0,0,0,.886-.917V16.917A.9.9,0,0,0,19.5,16Zm-.886,6.417H14.178V17.833h4.43v4.583ZM19.5,12.334H3.544a.873.873,0,0,0-.787.449.95.95,0,0,0,0,.934.873.873,0,0,0,.787.449H19.5a.918.918,0,0,0,0-1.834Z",
  transform: "translate(41 207)"
}));

var SvgIcDashboard = function SvgIcDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_dashboard.f85b57d0.svg";
export { ForwardRef as ReactComponent };